import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationWorkflowSaveFailedAction = {
	type: 'ORGANIZATION_WORKFLOW_SAVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationWorkflowSaveFailedAction => ({
	type: 'ORGANIZATION_WORKFLOW_SAVE_FAILED',
	payload,
});
